"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _checkTypes = _interopRequireDefault(require("check-types"));

var _moment = _interopRequireDefault(require("../../lib/moment"));

var _Fonts = require("../00_environment/Fonts");

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _ClosableInput = _interopRequireDefault(require("../01_atoms/ClosableInput"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _semanticUiReactNumberpicker = _interopRequireDefault(require("../../vendors/semantic-ui-react-numberpicker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BookingForm = function BookingForm(_ref) {
  var formFields = _ref.formData,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      translationManager = _ref.translationManager,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator,
      _ref$dropDownSearch = _ref.dropDownSearch,
      dropDownSearch = _ref$dropDownSearch === void 0 ? function () {} : _ref$dropDownSearch,
      departures = _ref.departures,
      arrivals = _ref.arrivals,
      _ref$dualPaneMode = _ref.dualPaneMode,
      dualPaneMode = _ref$dualPaneMode === void 0 ? false : _ref$dualPaneMode,
      _ref$onOriginFieldFoc = _ref.onOriginFieldFocus,
      onOriginFieldFocus = _ref$onOriginFieldFoc === void 0 ? function () {} : _ref$onOriginFieldFoc,
      _ref$onDestinationFie = _ref.onDestinationFieldFocus,
      onDestinationFieldFocus = _ref$onDestinationFie === void 0 ? function () {} : _ref$onDestinationFie,
      _ref$onOutboundDateFi = _ref.onOutboundDateFieldFocus,
      onOutboundDateFieldFocus = _ref$onOutboundDateFi === void 0 ? function () {} : _ref$onOutboundDateFi,
      _ref$onReturnDateFiel = _ref.onReturnDateFieldFocus,
      onReturnDateFieldFocus = _ref$onReturnDateFiel === void 0 ? function () {} : _ref$onReturnDateFiel,
      _ref$onFieldClear = _ref.onFieldClear,
      onFieldClear = _ref$onFieldClear === void 0 ? function () {} : _ref$onFieldClear,
      _ref$disableReturnFie = _ref.disableReturnField,
      disableReturnField = _ref$disableReturnFie === void 0 ? false : _ref$disableReturnFie;

  var selectedDeparture = formFields.selectedDeparture,
      selectedArrival = formFields.selectedArrival,
      numberOfPassengers = formFields.numberOfPassengers,
      outDate = formFields.outDate,
      returnDate = formFields.returnDate;
  var departureName = null;

  if (selectedDeparture && _checkTypes["default"].nonEmptyArray(departures)) {
    var d = departures.find(function (dep) {
      return dep.value === selectedDeparture;
    });

    if (d) {
      departureName = d.text;
    }
  }

  var arrivalName = null;

  if (selectedArrival && _checkTypes["default"].nonEmptyArray(arrivals)) {
    var a = arrivals.find(function (ar) {
      return ar.value === selectedArrival;
    });

    if (a) {
      arrivalName = a.text;
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Find your trip')
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
    style: {
      backgroundColor: 'none',
      width: '100%',
      marginTop: '5%',
      marginBottom: '5%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: (0, _Fonts.withFormLabelFont)({})
  }, t('From')), dualPaneMode ? /*#__PURE__*/_react["default"].createElement(_ClosableInput["default"], {
    id: "booking-form_from-field",
    value: departureName,
    placeholder: t('From'),
    onClick: function onClick() {
      return onOriginFieldFocus('booking-form_from-field');
    },
    onClear: function onClear() {
      _onChange(Object.assign(formFields, {
        selectedDeparture: null
      }));

      onFieldClear('selectedDeparture');
    }
  }) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    id: "booking-form_from-field",
    value: selectedDeparture,
    placeholder: t('From'),
    fluid: true,
    clearable: true,
    closeOnBlur: true,
    search: dropDownSearch,
    closeOnEscape: true,
    selection: true,
    options: departures,
    onChange: function onChange(e, o) {
      return _onChange(Object.assign(formFields, {
        selectedDeparture: o.value
      }));
    }
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: (0, _Fonts.withFormLabelFont)({})
  }, t('To')), dualPaneMode ? /*#__PURE__*/_react["default"].createElement(_ClosableInput["default"], {
    id: "booking-form_to-field",
    value: arrivalName,
    placeholder: t('To'),
    onClick: function onClick() {
      return onDestinationFieldFocus('booking-form_to-field');
    },
    onClear: function onClear() {
      _onChange(Object.assign(formFields, {
        selectedArrival: null
      }));

      onFieldClear('selectedArrival');
    }
  }) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    id: "booking-form_to-field",
    value: selectedArrival,
    placeholder: t('To'),
    fluid: true,
    clearable: true,
    closeOnBlur: true,
    closeOnEscape: true,
    selection: true,
    options: arrivals,
    onChange: function onChange(e, o) {
      return _onChange(Object.assign(formFields, {
        selectedArrival: o.value
      }));
    },
    search: dropDownSearch
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: (0, _Fonts.withFormLabelFont)({})
  }, t('Out date')), /*#__PURE__*/_react["default"].createElement(_ClosableInput["default"], {
    id: "booking-form_outDate-field",
    value: outDate ? (0, _moment["default"])(outDate, 'YYYY-MM-DD').locale(translationManager.getCurrentLanguage()).format('ll') : null,
    placeholder: t('Departure date'),
    valueLink: dualPaneMode ? null : '/book/details/departure-date',
    onClick: dualPaneMode ? function () {
      return onOutboundDateFieldFocus('booking-form_outDate-field');
    } : undefined,
    onClear: function onClear() {
      _onChange(Object.assign(formFields, {
        outDate: null,
        returnDate: null
      }));

      onFieldClear('outDate');
    }
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: (0, _Fonts.withFormLabelFont)({})
  }, t('Return date')), /*#__PURE__*/_react["default"].createElement(_ClosableInput["default"], {
    id: "booking-form_returnDate-field",
    disabled: disableReturnField,
    value: returnDate && !disableReturnField ? (0, _moment["default"])(returnDate, 'YYYY-MM-DD').locale(translationManager.getCurrentLanguage()).format('ll') : null,
    placeholder: disableReturnField ? t('No return possible for this route') : t('No return'),
    valueLink: dualPaneMode ? null : '/book/details/return-date',
    onClick: dualPaneMode ? function () {
      return onReturnDateFieldFocus('booking-form_returnDate-field');
    } : undefined,
    onClear: function onClear() {
      _onChange(Object.assign(formFields, {
        returnDate: null
      }));

      onFieldClear('returnDate');
    }
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: (0, _Fonts.withFormLabelFont)({})
  }, t('Number of passengers')), /*#__PURE__*/_react["default"].createElement(_semanticUiReactNumberpicker["default"], {
    id: "booking-form_numberOfPassengers-field",
    min: 1,
    name: "numberPicker",
    value: numberOfPassengers,
    onChange: function onChange(up) {
      return _onChange(Object.assign(formFields, {
        numberOfPassengers: up.value
      }));
    }
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    primary: true,
    fluid: true,
    disabled: !(selectedDeparture && selectedArrival && numberOfPassengers && outDate),
    onClick: function onClick() {
      return onSubmit(formFields);
    },
    style: {
      marginTop: 30
    }
  }, t('Search'))));
};

var _default = BookingForm;
exports["default"] = _default;